var crypto = require('crypto')
if (typeof crypto.randomFill === 'function' && typeof crypto.randomFillSync === 'function') {
  exports.randomFill = crypto.randomFill
  exports.randomFillSync = crypto.randomFillSync
} else {
  module.exports = require('./browser')
}



//////////////////
// WEBPACK FOOTER
// ./~/randomfill/index.js
// module id = 972
// module chunks = 0 1 2 3